export const orderStatusTypeOpenIds = [1, 2, 10, 11, 20, 21]
export const netSuiteOrderStatusTypeOpenIds = ['B', 'D', 'E', 'F']

export const orderStatusTypeCompleteIds = [3, 25, 22]
export const netSuiteOrderStatusTypeCompleteIds = ['G', 'H']

export const orderStatusTypePreviousIds = [1, 2, 3, 10, 11, 20, 21, 22, 25]

export const sortByDefaultSetting = '1' // 'Sort by' default to Model

export const projectId = 11 // 11 is the project_id for wholesale_frontend in the projects table
